import { useTranslation } from 'react-i18next';
import { ConnectisPrimaryLogo } from 'shared/icons';
import { ServiceUnavailableImg } from 'shared/icons/ServiceUnavailableImg';

export const ServiceUnavailablePage = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'common:serviceUnavailable',
  });

  return (
    <main className="min-h-full-device bg-background flex flex-col">
      <header className="bg-background h-[51px] w-full border-b border-black/20">
        <div className="max-w-container mx-auto flex h-full items-center px-4 lg:px-8">
          <ConnectisPrimaryLogo className="w-[120px]" />
        </div>
      </header>
      <div className="max-w-container mx-auto flex w-full flex-1 flex-col items-center justify-center gap-8 p-6 lg:flex-row lg:gap-16">
        <div>
          <ServiceUnavailableImg className="max-h-[360px] w-screen max-w-full p-4 px-[72px] lg:max-h-full lg:max-w-[519px] lg:px-0" />
        </div>
        <div className="max-w-[343px] space-y-3 text-center sm:my-4 md:max-w-[500px] lg:text-left">
          <h1 className="text-2xl font-medium">{t('title')}</h1>
          <p className="text-sm text-black/60 md:text-lg lg:whitespace-pre-line">{t('subtitle')}</p>
        </div>
      </div>
    </main>
  );
};

export default ServiceUnavailablePage;
